import React from "react"
import { BottomBar } from "../ui/Frame"
import { BlockContextConsumer } from "../ContextProviders"
import BreadCrumb from "../BreadCrumb"

const FooterBar = props => {
    return (
        <BottomBar>
            <BlockContextConsumer>
                {context => <BreadCrumb context={context} tree={props.instance} />}
            </BlockContextConsumer>
        </BottomBar>
    )
}

export default FooterBar



// WEBPACK FOOTER //
// ./src/features/editor/sidebars/FooterBar.js